// Send message icon
export const SendIcon = ({ color = "#0084ff" }) => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill={color}>
    <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
  </svg>
);

// Microphone icon
export const MicrophoneIcon = ({ color = "#65676b" }) => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill={color}>
    <path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm-1-9c0-.55.45-1 1-1s1 .45 1 1v6c0 .55-.45 1-1 1s-1-.45-1-1V5z" />
    <path d="M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z" />
  </svg>
);

// Attach file icon
export const AttachIcon = ({ color = "#65676b" }) => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill={color}>
    <path d="M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z" />
  </svg>
);

// Phone call icon
export const PhoneIcon = ({ color = "#65676b" }) => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill={color}>
    <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
  </svg>
);

// Video call icon
export const VideoIcon = ({ color = "#65676b" }) => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill={color}>
    <path d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z" />
  </svg>
);

// Reply icon
export const ReplyIcon = ({ color = "#65676b" }) => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill={color}>
    <path d="M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z" />
  </svg>
);

// Forward icon
export const ForwardIcon = ({ color = "#65676b" }) => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill={color}>
    <path d="M14 9V5l7 7-7 7v-4.1c-5 0-8.5 1.6-11 5.1 1-5 4-10 11-11z" />
  </svg>
);

// Delete icon
export const DeleteIcon = ({ color = "#65676b" }) => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill={color}>
    <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" />
  </svg>
);

// Emoji icon
export const EmojiIcon = ({ color = "#65676b" }) => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill={color}>
    <circle cx="15.5" cy="9.5" r="1.5" />
    <circle cx="8.5" cy="9.5" r="1.5" />
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-4c-1.48 0-2.75-.81-3.45-2H6.88c.8 2.05 2.79 3.5 5.12 3.5s4.32-1.45 5.12-3.5h-1.67c-.7 1.19-1.97 2-3.45 2z" />
  </svg>
);

// Image icon
export const ImageIcon = ({ color = "#65676b" }) => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill={color}>
    <path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z" />
  </svg>
);

// Document icon
export const DocumentIcon = ({ color = "#65676b" }) => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill={color}>
    <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z" />
  </svg>
);

// Location icon
export const LocationIcon = ({ color = "#65676b" }) => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill={color}>
    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
  </svg>
);

// Search icon
export const SearchIcon = ({ color = "#65676b" }) => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill={color}>
    <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
  </svg>
);

// Back arrow icon
export const BackIcon = ({ color = "#65676b" }) => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill={color}>
    <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
  </svg>
);

// More options (vertical dots)
export const MoreIcon = ({ color = "#65676b" }) => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill={color}>
    <path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
  </svg>
);

// Check marks for message status
export const SingleCheckIcon = ({ color = "#65676b" }) => (
  <svg viewBox="0 0 16 16" width="16" height="16" fill={color}>
    <path d="M6.5 12.5l-4-4 1.41-1.41L6.5 9.67l6.09-6.09L14 5l-7.5 7.5z" />
  </svg>
);

export const DoubleCheckIcon = ({ color = "#65676b" }) => (
  <svg viewBox="0 0 16 16" width="16" height="16" fill={color}>
    <path d="M1.5 9l3 3 1.5-1.5-3-3L1.5 9zm4 3l7-7-1.5-1.5-7 7L5.5 12zm3.5-3l3 3 6-6-1.5-1.5-4.5 4.5-1.5-1.5L9 9z" />
  </svg>
);

// Close icon
export const CloseIcon = ({ color = "#65676b" }) => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill={color}>
    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
  </svg>
);

// Group icon
export const GroupIcon = ({ color = "#65676b" }) => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill={color}>
    <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
  </svg>
);

// Translate icon
export const TranslateIcon = ({ color = "#65676b" }) => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill={color}>
    <path d="M12.87 15.07l-2.54-2.51.03-.03c1.74-1.94 2.98-4.17 3.71-6.53H17V4h-7V2H8v2H1v1.99h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12zm-2.62 7l1.62-4.33L19.12 17h-3.24z" />
  </svg>
);

// Speaker icon (for text-to-speech)
export const SpeakerIcon = ({ color = "#65676b" }) => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill={color}>
    <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z" />
  </svg>
);

// Stop icon (for recording)
export const StopIcon = ({ color = "#e41e3f" }) => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill={color}>
    <path d="M6 6h12v12H6z" />
  </svg>
);

// Play icon
export const PlayIcon = ({ color = "#65676b" }) => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill={color}>
    <path d="M8 5v14l11-7z" />
  </svg>
);

// Pause icon
export const PauseIcon = ({ color = "#65676b" }) => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill={color}>
    <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z" />
  </svg>
);

// End call icon
export const EndCallIcon = ({ color = "#fff" }) => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill={color}>
    <path d="M12 9c-1.6 0-3.15.25-4.6.72v3.1c0 .39-.23.74-.56.9-.98.49-1.87 1.12-2.66 1.85-.18.18-.43.28-.7.28-.28 0-.53-.11-.71-.29L.29 13.08c-.18-.17-.29-.42-.29-.7 0-.28.11-.53.29-.71C3.34 8.78 7.46 7 12 7s8.66 1.78 11.71 4.67c.18.18.29.43.29.71 0 .28-.11.53-.29.71l-2.48 2.48c-.18.18-.43.29-.71.29-.27 0-.52-.11-.7-.28-.79-.74-1.69-1.36-2.67-1.85-.33-.16-.56-.5-.56-.9v-3.1C15.15 9.25 13.6 9 12 9z" />
  </svg>
);

// Mute mic icon
export const MuteMicIcon = ({ color = "#65676b" }) => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill={color}>
    <path d="M19 11h-1.7c0 .74-.16 1.43-.43 2.05l1.23 1.23c.56-.98.9-2.09.9-3.28zm-4.02.17c0-.06.02-.11.02-.17V5c0-1.66-1.34-3-3-3S9 3.34 9 5v.18l5.98 5.99zM4.27 3L3 4.27l6.01 6.01V11c0 1.66 1.33 3 2.99 3 .22 0 .44-.03.65-.08l1.66 1.66c-.71.33-1.5.52-2.31.52-2.76 0-5.3-2.1-5.3-5.1H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c.91-.13 1.77-.45 2.54-.9L19.73 21 21 19.73 4.27 3z" />
  </svg>
);

// Camera off icon
export const CameraOffIcon = ({ color = "#65676b" }) => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill={color}>
    <path d="M21 6.5l-4 4V7c0-.55-.45-1-1-1H9.82L21 17.18V6.5zM3.27 2L2 3.27 4.73 6H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.21 0 .39-.08.54-.18L19.73 21 21 19.73 3.27 2z" />
  </svg>
);

// Screen share icon
export const ScreenShareIcon = ({ color = "#65676b" }) => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill={color}>
    <path d="M20 18c1.1 0 1.99-.9 1.99-2L22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z" />
    <path d="M12 8l-4 4h3v4h2v-4h3l-4-4z" />
  </svg>
);

// Conference icon
export const ConferenceIcon = ({ color = "#65676b" }) => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill={color}>
    <path d="M4 4h16v12H5.17L4 17.17V4m0-2c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4z" />
    <circle cx="8" cy="10" r="1.5" />
    <circle cx="12" cy="10" r="1.5" />
    <circle cx="16" cy="10" r="1.5" />
  </svg>
);

// Camera icon
export const CameraIcon = ({ color = "#65676b" }) => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill={color}>
    <path d="M12 15c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3z" />
    <path d="M20 4h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 13c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z" />
  </svg>
);

// Check icon
export const CheckIcon = ({ color = "#65676b" }) => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill={color}>
    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
  </svg>
);

// Info icon
export const InfoIcon = ({ color = "#65676b" }) => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill={color}>
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" />
  </svg>
);

// Edit icon
export const EditIcon = ({ color = "#65676b" }) => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill={color}>
    <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
  </svg>
);

// Link icon
export const LinkIcon = ({ color = "#65676b" }) => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill={color}>
    <path d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z" />
  </svg>
);

// Settings icon
export const SettingsIcon = ({ color = "#65676b" }) => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill={color}>
    <path d="M19.14 12.94c.04-.31.06-.63.06-.94 0-.31-.02-.63-.06-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.04.31-.06.63-.06.94s.02.63.06.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z" />
  </svg>
);

// Exit icon
export const ExitIcon = ({ color = "#65676b" }) => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill={color}>
    <path d="M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" />
  </svg>
);

// Add person icon
export const AddPersonIcon = ({ color = "#65676b" }) => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill={color}>
    <path d="M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm-9-2V7H4v3H1v2h3v3h2v-3h3v-2H6zm9 4c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
  </svg>
);

// Admin/Crown icon
export const AdminIcon = ({ color = "#65676b" }) => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill={color}>
    <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z" />
  </svg>
);

// Copy icon
export const CopyIcon = ({ color = "#65676b" }) => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill={color}>
    <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" />
  </svg>
);

// Download icon
export const DownloadIcon = ({ color = "#65676b" }) => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill={color}>
    <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" />
  </svg>
);
